import store from "@/store";
import axios from "axios";
import {toast} from "../class/Notification";
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const courseDataShape = (form) => {
    let formData = new FormData();

    formData.append("thumbnail", form.thumbnail);
    formData.append("title", form.title);
    formData.append("body", form.body);
    if (form.description != null && form.description.length > 0) {
        formData.append("description", form.description);
    }

    if (form.spot_player_course_id != null && form.spot_player_course_id.length > 0) {
        formData.append("spot_player_course_id", form.spot_player_course_id);
    }

    formData.append("abstract", form.abstract);
    formData.append("slug", form.slug);

    formData.append("course_status", form.course_status ? 1 : 0);
    formData.append("status", form.status ? 1 : 0);
    formData.append("language_id", form.language_id);

    for (let i in form.courseProducts) {
        const item = form.courseProducts[i];
        formData.append(`products[${i}][product_id]`, item.product_id);
        if (item.sub_product_id !== undefined) {
            formData.append(`products[${i}][sub_product_id]`, item.sub_product_id);
        }
    }

    return formData;
};

export default {
    namespaced: true,
    state: {
        courses: [],
        products: [],
        course: {},
        trash: [],
        meta: {},
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
        setCourses(state, courses) {
            state.courses = courses;
        },
        setCourse(state, course) {
            state.course = course;
        },
        setProducts(state, products) {
            state.products = products
        },
        deleteCourse(state, course) {
            state.courses.splice(
                findObjectIndex(store.getters["Course/getCourses"], course),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["Course/getTrash"], course),
                1
            );
        },
        setTrash(state, courses) {
            state.trash = courses;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
    },
    actions: {
        getProducts({commit, state}) {
            axios.get(`dashboard/product?is_digital=1`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setProducts", products.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setCourses({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            axios.get(`course?page=${page}&${query}`)
                .then((res) => {
                    let courses = res.data.data;
                    commit("setCourses", courses.data);
                    commit("setMeta", courses.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setDashboardCourses({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            axios.get(`dashboard/course?page=${page}&${query}`)
                .then((res) => {
                    let courses = res.data.data;
                    commit("setCourses", courses.data);
                    commit("setMeta", courses.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        createCourse({commit, getters}, form) {

            form = courseDataShape(form);


            axios
                .post("/course", form)
                .then((res) => {
                    const course = res.data.data;
                    toast('', 'دوره با موفقیت ثبت شد')
                    router.push({name: 'EditCourse', params: {slug: course.slug}});
                    commit('setCourse', course);
                })
                .catch((error) => {
                    console.log(error.message);
                });

        },
        updateCourse({commit, getters}, form) {

            let formData = courseDataShape(form);

            if (form.thumbnail === undefined || form.thumbnail.length === 0) {
                formData.delete("thumbnail");
            }

            formData.append("_method", "PUT");

            axios
                .post(`/course/${form.id}`, formData)
                .then((res) => {
                    const course = res.data.data;
                    commit("setCourse", course);
                    toast('', 'دوره با موفقیت ویرایش شد')
                    router.push({
                        name: "EditCourse",
                        params: {slug: course.slug},
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

        },

        getCourse({commit}, slug) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`course/${slug}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setCourse", response);
                        resolve(response);
                    })
                    .catch((error) => {
                        router.push({name: "AllCourses"});
                        console.log(error);
                    });
            });
        },
        getDashboardCourse({commit}, slug) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`dashboard/single/course/${slug}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setCourse", response);
                        resolve(response);
                    })
                    .catch((error) => {
                        router.push({name: "AllCourses"});
                        console.log(error);
                    });
            });
        },
        deleteCourse({commit}, course) {
            axios
                .delete(`/course/${course.id}`)
                .then((res) => {
                    commit("deleteCourse", course);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTrash({commit}, page = 1) {
            axios
                .post(`/course/trash?page=${page}`)
                .then((res) => {
                    let courses = res.data.data;
                    commit("setTrash", courses.data);
                    commit("setMeta", courses.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreCourse({commit}, course) {
            axios
                .put(`/course/${course.id}/restore`)
                .then((res) => {
                    const restoredCourse = res.data.data;
                    commit("deleteCourse", restoredCourse);
                    const courses = {
                        ...store.getters["Course/getCourses"],
                        restoredCourse,
                    }; // todo : fix issue of send array inested of object
                    commit("setCourses", Object.keys(courses));
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDeleteCourse({commit}, course) {
            axios
                .delete(`/course/${course.id}/force-delete`)
                .then((res) => {
                    toast(res.data.status, res.data.message)

                    commit("deleteCourse", course);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        searchProducts({commit, state}, words) {
            const formData = new FormData();
            formData.append('words', words)
            axios
                .post(`/product/general-search?is_digital=1&${state.filters.language}`, formData)
                .then(res => {
                    const data = res.data.data;
                    commit('setProducts', data)
                }).catch(err => {
                console.log(err.message)
            })
        },
        dashboardSearchForDigitalProduct({commit, state}, words) {
            axios
                .post(`/product/search?is_digital=1&words=${words}`)
                .then(res => {
                    const data = res.data.data;
                    commit('setProducts', data.data)
                }).catch(err => {
                console.log(err.message)
            })
        },
        addUserToCourse({commit}, form) {
            axios
                .post("/course/add-user-to-course", form)
                .then((res) => {
                    const course = res.data.data;
                    console.log(course)
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
        getCourseWithoutState({commit}, slug) {
            return axios.get(`course/${slug}`)
        },
        getUserCourses({commit}, form) {
            return axios.post(`user/${form.user_id}/courses?page=${form.page}`)
        },
        getLessonNextPerv({commit}, form) {
            return axios.get(`lesson/get-next-per-lesson/course/${form.courseSlug}/lesson/${form.lessonSlug}`)
        }
    },
    getters: {
        getCourses: (state) => state.courses,
        getCourse: (state) => state.course,
        getProducts: (state) => state.products,
        getCourseProducts: (state) => state.course.products,
        getTrash: (state) => state.trash,
        getPaginationMeta: (state) => state.meta,
        getFilters: (state) => state.filters,
    },
};
